export default __webpack_public_path__ + "static/media/logo.fcaf6fc2.svg";